<template>
  <div>
    <span class="link" @click="toggleOpen">{{ callId }}</span>
    <call-details-modal
      v-if="open"
      :call-id="callId"
      @hide-modal="toggleOpen"
    ></call-details-modal>
  </div>
</template>

<script>
import CallDetailsModal from "@/CallComponents/CallDetailsModal.vue";
export default {
  components: {
    CallDetailsModal,
  },
  props: {
    callId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      open: false,
    };
  },
  methods: {
    toggleOpen() {
      this.open = !this.open;
    },
  },
};
</script>

<style lang="scss" scoped></style>
